import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

export default function SportTypeSelect(args: any) {
  const [age, setAge] = React.useState('');
    const [func] = React.useState(args.setSportTypeId);
  const handleChange = async (event: SelectChangeEvent) => {
    const value = event.target.value as string
    setAge(value);
    await func.setSportTypeId(value)
  };

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">Sport</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={age}
          label="Score type"
          onChange={handleChange}
        >
          <MenuItem value={0}>Football</MenuItem>
          <MenuItem value={1}>Basketball</MenuItem> 
        </Select>
      </FormControl>
    </Box>
  );
}